'use client';

import { useEffect, useState } from 'react';

import { useFlowbox } from './flow-box-context';
import styles from './FlowboxTags.module.scss';

declare global {
  interface Window {
    flowbox?: ((...args: any[]) => void) & { q?: any[] };
  }
}
//TODO handle productId

export function FlowboxEmbed() {
  const {
    containerId = 'js-flowbox-flow',
    flowKey,
    locale = 'sv-SE',
    showTags = true,
    tags,
    viewAll,
  } = useFlowbox();

  const tagsArray = tags ? tags.split(',').map((tag) => tag.trim()) : [];
  const [activeTag, setActiveTag] = useState<null | string>(null);

  useEffect(() => {
    if (!window.flowbox) {
      const f: ((...args: any[]) => void) & { q: any[] } = (...args: any[]) => {
        f.q.push(args);
      };
      f.q = [];
      window.flowbox = f;
    }

    const existingScript = document.getElementById('flowbox-js-embed');

    const initFlow = () => {
      window.flowbox?.('init', {
        container: `#${containerId}`,
        key: flowKey,
        locale,
        tags: tagsArray,
        tagsOperator: 'any',
      });
    };

    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'flowbox-js-embed';
      script.async = true;
      script.src = 'https://connect.getflowbox.com/flowbox.js';
      document.body.appendChild(script);
      script.onload = initFlow;
    } else {
      initFlow();
    }
  }, [flowKey, locale, containerId, tags]);

  const updateFlowbox = (tag: null | string) => {
    if (!window.flowbox) return;

    if (tag === null) {
      window.flowbox('update', {
        key: flowKey,
        tags: tagsArray,
        tagsOperator: 'any',
      });
    } else {
      window.flowbox('update', {
        key: flowKey,
        tags: [tag],
        tagsOperator: 'all',
      });
    }
    setActiveTag(tag);
  };

  return (
    <>
      {showTags && tagsArray.length > 0 && (
        <div className={styles['tags']}>
          <button
            className={`${styles['button']} ${
              activeTag === null ? styles['active'] : ''
            }`}
            onClick={() => updateFlowbox(null)}
          >
            {viewAll || 'View All'}
          </button>
          {tagsArray.map((tag) => (
            <button
              className={`${styles['button']} ${
                activeTag === tag ? styles['active'] : ''
              }`}
              key={tag}
              onClick={() => updateFlowbox(tag)}
            >
              {tag}
            </button>
          ))}
        </div>
      )}
      <div id={containerId} />
    </>
  );
}
